import { Box } from '@mui/material';
import { RenderTable } from '../../../../components/ui';
import TBody from './TBody';
import TFoot from './TFoot';
import THead from './THead';
import { IData } from '../../helpers/interface';

interface IProps {
  moduleData: IData;
  isView: boolean;
  machineData: any;
}

const TController = ({
  moduleData,
  isView,
  machineData,
}: // setIsOpenPopup,
// setPartIdx,
IProps) => {
  return (
    <Box>
      <RenderTable>
        <THead
          {...{
            moduleData,
            isView,
            machineData,
          }}
        />
        <TBody
          {...{
            moduleData,
            isView,
          }}
        />
        <TFoot
          preparedBy={moduleData.report_prepared_by}
          approvedBy={moduleData.report_approved_by}
          {...{ moduleData, isView }}
        />
      </RenderTable>
    </Box>
  );
};

export default TController;
